"use client"

import { Regex } from "lucide-react"
import { component, Icon } from "../icon"

/**
 * `RegexIcon` is [Lucide](https://lucide.dev) SVG icon component.
 *
 * @see https://yamada-ui.com/docs/components/icon
 */
export const RegexIcon = component(Icon)({ as: Regex })
